import type { ComponentPropsWithoutRef, ReactNode } from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import remarkMath from 'remark-math'
import rehypeKatex from 'rehype-katex'
import rehypeHighlight from 'rehype-highlight'
import changesMarkdown from '../../../../changes.md?raw'
import { APP_BASE_PATH } from '../config'

import 'katex/dist/katex.min.css'
import 'highlight.js/styles/github.css'
import './ChangesPage.css'

function extractText(node: ReactNode): string {
    if (typeof node === 'string') return node
    if (typeof node === 'number') return String(node)
    if (Array.isArray(node)) return node.map(extractText).join('')
    if (node && typeof node === 'object' && 'props' in node) {
        return extractText((node as { props: { children?: ReactNode } }).props.children)
    }
    return ''
}

function appRootHref(): string {
    return APP_BASE_PATH
}

export default function ChangesPage() {
    return (
        <main className="changes-page">
            <header className="changes-page__header">
                <div>
                    <p className="changes-page__eyebrow">SecureBlob</p>
                    <h1>Changes</h1>
                    <p className="changes-page__intro">
                        Kort changelog över vad som faktiskt har landat och vad som ser ut att komma härnäst.
                    </p>
                </div>
                <a className="changes-page__home-link" href={appRootHref()}>
                    Till webappen
                </a>
            </header>

            <article className="changes-page__content markdown-body">
                {(() => {
                    let headingIndex = 0
                    return (
                <ReactMarkdown
                    remarkPlugins={[remarkGfm, remarkMath]}
                    rehypePlugins={[rehypeKatex, rehypeHighlight]}
                    skipHtml
                    components={{
                        h1(props: ComponentPropsWithoutRef<'h1'>) {
                            headingIndex += 1
                            const className = headingIndex === 1 ? 'changes-page__hidden-h1' : undefined
                            return <h1 {...props} className={className} />
                        },
                        p(props: ComponentPropsWithoutRef<'p'>) {
                            const text = extractText(props.children).trim()
                            if (text.startsWith('Meta:')) {
                                return <p {...props} className="changes-page__meta" />
                            }
                            if (text.startsWith('Uppdaterad:')) {
                                return <p {...props} className="changes-page__updated" />
                            }
                            return <p {...props} />
                        },
                    }}
                >
                    {changesMarkdown}
                </ReactMarkdown>
                    )
                })()}
            </article>
        </main>
    )
}
